import type { DepositAccount } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

const useGetInternalAndExternalDepositAccounts = requestBuilder.query<
    DepositAccount[]
>({
    endpoint: () =>
        '/api/depository-transfer/list-accounts?type=ACTIVE_DEPOSITORY_INTERNAL_EXTERNAL',
    queryKey: () =>
        'depository-transfer/list-accounts/ACTIVE_DEPOSITORY_INTERNAL_EXTERNAL',
});

export default useGetInternalAndExternalDepositAccounts;
